import { Component, input } from '@angular/core'
import { ColDef, GetRowIdFunc } from 'ag-grid-community'
import { AgGridAngular } from 'ag-grid-angular'
import { TableLoadingOverlayComponent } from './overlays/table-loading-overlay.component'
import { TableNoDataOverlayComponent } from './overlays/table-no-data-overlay.component'
import { TableSortService } from './services/table-sort.service'
import { IntervalUsage } from 'src/app/shared/models/intervalUsage'
import { UpdateIntervalUsageColumnDefinition } from './definitions/update-interval-usage-column-definition'

@Component({
  selector: 'app-update-interval-usage-table',
  imports: [AgGridAngular],
  providers: [TableSortService],
  styles: `
      :host {
          display: flex;
          flex-direction: column;
          justify-content: start;
      }
    `,
  template: `
    <ag-grid-angular
      class="app-table"
      style="height: 40vh"
      [getRowId]="getRowId"
      [columnDefs]="columnDefs"
      [rowData]="data()"
      [suppressNoRowsOverlay]="loading()"
      [suppressPaginationPanel]="true"
      [suppressDragLeaveHidesColumns]="true"
      [loadingOverlayComponent]="loadingOverlayComponent"
      [noRowsOverlayComponent]="noRowsOverlayComponent"
      [noRowsOverlayComponentParams]="noRowsOverlayParams"
      [pagination]="false"
      [enableCellTextSelection]="true"
      [loading]="loading()"
    />
  `,
})
export class UpdateIntervalUsageTableComponent {
  readonly loading = input.required<boolean>()
  readonly data = input.required<IntervalUsage[]>()

  protected readonly getRowId: GetRowIdFunc<IntervalUsage> = (data) =>
    `${data.data.service_point_uid}|${data.data.market_interval}`

  protected readonly columnDefs: ColDef[] = new UpdateIntervalUsageColumnDefinition().getColDefs()

  protected readonly loadingOverlayComponent = TableLoadingOverlayComponent
  protected readonly noRowsOverlayComponent = TableNoDataOverlayComponent
  protected readonly noRowsOverlayParams = { error: false }
}
